import config from '@platform/shared/config';
import * as rpc from '@platform/components/rpc';
import { computed, ref } from 'vue';
import { AuthRoutines, UserStore } from '@platform/store';

/**
 * @deprecated Скажеим нет зашитым ролям! Тем более, они перестанут работать
 * @type {{PTO_CHIEF: string, ACCOUNTANT: string, GUEST: string, MANAGER: string, DOC: string, LAWYER: string, CURATOR: string, SUPPLY: string, PTO: string, ADMIN: string}}
 */
export const roles = {
    ADMIN: 'ROLE_ADMIN',
    MANAGER: 'ROLE_MANAGER',
    SUPPLY: 'ROLE_SUPPLIER',
    PTO: 'ROLE_PTO',
    DOC: 'ROLE_DOC',
    LAWYER: 'ROLE_LAWYER',
    PTO_CHIEF: 'ROLE_PTO_CHIEF',
    ACCOUNTANT: 'ROLE_ACCOUNTANT',
    GUEST: 'ROLE_GUEST',
    CURATOR: 'ROLE_CURATOR',
};

const guest = ref(null),
    isGuest = computed(() => guest.value != null);

guest.value = config.getItemStorage('guest_link') || null;

export default {
    guest,
    isGuest,
    roleTypes: roles, //перечисление типов РОЛЕЙ
    getUserRoles: funcGetUserRoles, //возвращает список РОЛЕЙ текущего пользователя
    getUserFIO: funcGetUserFIO, //возвращает ФИО текущего пользователя
    /**
     * @deprecated Проверка кодов ролей станет недоступна 08.04.2023
     */
    checkUserRoles: funcCheckUserRoles, //проверяет наличие РОЛЕЙ у текущего пользователя (на входе - массив проверяемых РОЛЕЙ)
    logOut: funcLogOut, //выход из сессии и перезагрузка страницы до логинки

    getCurrentEmployeeId: rpc.funcGetCurrentEmployeeId, //возвращает employee_id по текущему авторизованному пользователю
    getInfoCurrentEmployeeId: rpc.funcGetInfoCurrentEmployeeId, // возвращает всю информацию организации  по текущему авторизованному пользователю (либо переданным employee_id)
    ensureClientUpdated: funcEnsureClientUpdated,
    setClientUpdated: funcSetClientUpdated,
    executeLoginRoutines: async (login, username) => {
        if (!login) return;
        const res = await AuthRoutines.fetchUserData(login);
        if (!res) return;
        localStorage.setItem(config.idToken, login.id_token);
        localStorage.setItem(config.lifetimeToken, Date.now() + config.lifetimeValue); //12 часов
        localStorage.setItem(config.currUserFIO, login.user_fio);
        localStorage.setItem(config.currExtUserId, login.user_id);
        localStorage.setItem(config.login, username);
        localStorage.setItem(
            'REFRESH_TOKEN',
            JSON.stringify({
                refreshToken: login.refresh_token,
                expires: login.refresh_token_expires_at,
            })
        );

        const query_response_user = res.userRes;
        if (query_response_user?.length > 0) {
            localStorage.setItem(config.currUserId, query_response_user.id);
            localStorage.setItem(config.currUserPersonId, query_response_user.person_id?.value);
        }
        const query_response_org_link = res.orgsRes;
        let mainOrgName = null;
        if (query_response_org_link) {
            let mainOrg,
                localStorageOrg,
                changeOrg = true;
            if (UserStore.userState.sysParams.sysOrgId) {
                localStorageOrg = UserStore.userState.sysParams.sysOrgId;
            }
            query_response_org_link.forEach((item) => {
                if (item.main) {
                    mainOrgName = item.name;
                    mainOrg = {
                        label: item.name,
                        value: item.id,
                        name: item.name,
                        post: item.post,
                        roles: item.role_code,
                        contragent_id: item.contragent_id,
                    };
                }
                if (localStorageOrg === item.id) {
                    changeOrg = false;
                    config.setItemStorage('sysServiceOrg', item.id);
                    config.setItemStorage('sysServiceOrgName', item.name);
                    config.setItemStorage('sysMainPost', item.post);
                    if (config.getItemStorage('sysWithoutHierarchy') == null) {
                        config.setItemStorage('sysWithoutHierarchy', false);
                    }
                    config.setItemStorage(config.currUserRoles, item.role_code);
                    config.setItemStorage(config.ourContragent, item.contragent_id);
                }
            });
            if (changeOrg) {
                config.setItemStorage('sysServiceOrg', mainOrg.value);
                config.setItemStorage('sysServiceOrgName', mainOrg.label);
                config.setItemStorage('sysMainPost', mainOrg.post);
                config.setItemStorage('sysWithoutHierarchy', false);
                config.setItemStorage(config.currUserRoles, mainOrg.roles);
                config.setItemStorage(config.ourContragent, mainOrg.contragent_id);
            }
            return { mainOrgName };
        }
    },
};

function funcEnsureClientUpdated() {
    if (localStorage.getItem('version.current') !== config.currentVersion) {
        funcLogOut(true);
    }
}

function funcSetClientUpdated() {
    if (localStorage.getItem('version.current') !== config.currentVersion) {
        localStorage.setItem('version.current', config.currentVersion);
    }
}

function funcGetUserRoles() {
    const userRolesString = config.getItemStorage(config.currUserRoles);
    if (!userRolesString || userRolesString.length === 0) {
        return [];
    }
    //todo Косяк в том, что можно "руками" подменить в localStorage роли и получить полные права
    //Надо хешировать имена и контрольную сумму с ними, либо делать иной механизм
    const userRoles = userRolesString.split(',');
    for (let i = 0; i < userRoles.length; i++) {
        userRoles[i] = userRoles[i] ? userRoles[i].trim() : '';
    }
    if (!userRoles) return [];
    return userRoles;
}

function funcGetUserFIO() {
    return localStorage.getItem(config.currUserFIO);
}

/**
 * @deprecated Проверка кодов ролей станет недоступна 08.04.2023
 * @see platform/shared/lib/roles
 * @param roles
 * @returns {boolean}
 */
function funcCheckUserRoles(roles) {
    if (!roles) {
        return true;
    }
    const userRoles = UserStore.userState.user?.roles;
    if (!userRoles) return false;
    for (const role of roles) {
        // if (userRoles.toLocaleUpperCase().search(role.toLocaleUpperCase()) >= 0) {
        if (userRoles.includes(role)) {
            return true;
        }
    }
    return false;
}

function funcLogOut() {
    localStorage.removeItem(config.idToken);
    localStorage.removeItem(config.lifetimeToken);
    localStorage.removeItem(config.currUserFIO);
    localStorage.removeItem(config.currExtUserId);
    // TODO: remove old role persistence
    localStorage.removeItem(config.currUserRoles);
    localStorage.removeItem(config.idToken);
    localStorage.removeItem(config.currUserId);
    // if (toMainPage) window.location = '/';
    // else window.location.reload(false);
    // console.log('logout');
    AuthRoutines.onLogout();
}
